/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Dropdown, Checkbox, Tag, Popconfirm,
  Popover,
  Select,
  Divider,
} from 'antd';
import {
  EditOutlined, ControlOutlined, DeleteOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import QCPointActions from '@Actions/quality/qcPointActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import UpdateProductGroup from '../UpdateProductGroup';
import QCPointForm from '../QCPointForm';
import PRZText from '../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView';
import ListScreenKeys from './mobileListHelpers';
import PRZSelect from '../../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../../hooks/useCheckPortrait';
import './style.scss';
import {
  toISTDate, dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '@Apis/constants';
import UserSavedFilterViewSelector from '@Components/Common/UserSavedFilterViewSelector';

const fixedColumns = ['QC_POINT_CODE', 'TITLE', 'OPERATIONS'];
const { Option } = Select;

/**
 *
 */
function QCPointList({
  qualityControlPoints, qualityControlPointsLoading, user, getQCPoints, history, deleteQCPointGroup, deleteQCPointGroupLoading, getQCPointsReportLoading, getQCPointsReport, getOrgUsers, orgUsers,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [showNewQCPointModal, setShowNewQCPointModal] = useState(false);
  const [showUpdateQCPointModal, setShowUpdateQCPointModal] = useState(false);
  const [showUpdateProductGroupModal, setShowUpdateProductGroupModal] = useState(false);
  const [selectedQCPoint, setSelectedQCPoint] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-qcr') ? JSON.parse(localStorage.getItem('prcz-page-columns-qcr')) : {
    QC_POINT_CODE: {
      label: 'QC Rule #',
      visible: true,
    },
    TITLE: {
      label: 'Title',
      visible: true,
    },
    OPERATIONS: {
      label: 'Operations',
      visible: true,
    },
    ASSIGNEES: {
      label: 'Assignees',
      visible: true,
    },
    // CONTROL_PER: {
    //   label: 'Control Per',
    //   visible: true,
    // },
    PRODUCT_COUNT: {
      label: 'Product Count',
      visible: true,
    },
    CONTROL_FREQUENCY: {
      label: 'Control Frequency',
      visible: true,
    },
  });
  const [call, setCall] = useState(false);
  const [selectedQCPointForMobile, setSelectedQCPointForMobile] = useState({});
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  // saved filter views states
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getOperationLabel = (operation) => {
    switch (operation) {
      case 'good_receiving_note':
        return 'Purchase Receipt';
      case 'manufacturing_order':
        return 'Manufacturing Order';
      case 'good_receiving_note_internal_stock_transfer':
        return 'Internal Transfer Receipt';
      case 'good_receiving_note_external_stock_transfer':
        return 'External Transfer Receipt';
      default:
        return '-';
    }
  };

  const getQCPointColumns = () => {
    const qcPointColumns = [
      {
        title: '',
        render: (record) => {
          const selectedUsers = record?.assignees?.map((assignee) => ({
            userId: assignee?.user_id,
            title: assignee?.first_name,
            identity: assignee?.identity,
          })) || [];
          return (
            <div className="mobile-list__card">
              <div className="mobile-list__card_header">
                <div className="mobile-list__card_header-left">
                  <PRZText text={`#${record?.qcr_number}`} className="mobile-list__card_item-number" />
                </div>
              </div>
              <div className="mobile-list__card_body">
                <div className="mobile-list__card_body-left" style={{ width: '100%' }}>
                  {record?.quality_control_name && (
                    <div className="mobile-list__card_item-name_wrapper">
                      <PRZText text={`Title - ${record?.quality_control_name}`} className="mobile-list__card_item-name" />
                    </div>
                  )}
                  {/* <H3Text */}
                  {/*  text={`Control Per - ${record?.control_per}`} */}
                  {/*  className="mobile-list__item-info" */}
                  {/* /> */}
                  <PRZText
                    text={`Control Frequency - ${record?.control_frequency}`}
                    className="mobile-list__card_item-details"
                  />
                  {/* <div className="vendor-mobile-list__item-footer">
                  <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer-left" />
                </div> */}
                </div>
                <div className="mobile-list__card_body-right">
                  <div className="mobile-list__card_item_status_wrapper">
                    <PRZText text={`${record?.products?.length}`} className="mobile-list__card_item_status_title" />
                  </div>
                </div>
              </div>
              <Divider className="mobile-list__card_divider" />
              <div className="mobile-list__card_footer">
                <div className="mobile-list__card_footer-left">
                  {record?.assignees?.length > 0 ? (
                    <SelectUser
                      dontShowUnassigned
                      selectedUsers={selectedUsers}
                      disabled
                      removeAddUser
                    />
                  ) : (
                    '-'
                  )}
                </div>
                <div className="mobile-list__card_footer-right">
                  <PRZText
                    className="mobile-list__card__view-more_wrapper"
                    onClick={() => {
                      setSelectedQCPointForMobile(record);
                      setMoreDetailsDrawer(true);
                    }}
                    text={(
                      <span className="mobile-list__card__view-more-text_wrapper">
                        <span className="mobile-list__card__view-more-text">More Info</span>
                        <FontAwesomeIcon
                          className="mobile-list__card__view-more-icon"
                          icon={faAnglesRight}
                        />
                      </span>
                    )}
                  />
                </div>
              </div>
            </div>
          );
        },
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'QC Rule #',
        // width: '120px',
        // dataIndex: 'qcr_number',
        render: (record) => (
          <div className="column-number__wrapper">
            {record?.qcr_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.QC_POINT_CODE?.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'Title',
        // width: '250px',
        render: (text, record) => (
          <div className="">
            {record?.quality_control_name}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.TITLE?.visible ? 'display-none' : '',
      },
      {
        title: 'OPERATIONS',
        // width: '450px',
        render: (text, record) => (
          <Fragment>
            <div className="qc-tags__wrapper">
              {record?.operations?.map((operation) => (
                <div key={operation} className="qc-tags">
                  {getOperationLabel(operation)}
                </div>
              ))}
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.OPERATIONS?.visible ? 'display-none' : '',
      },
      {
        title: 'Assignees',
        render: (text, record) => {
          const selectedUsers = record?.assignees?.map((assignee) => ({
            userId: assignee?.user_id,
            title: assignee?.first_name,
            identity: assignee?.identity,
          })) || [];

          return (
            <div className='min-width-50'>
              {record?.assignees?.length > 0 ? (
                <SelectUser
                  dontShowUnassigned
                  selectedUsers={selectedUsers}
                  disabled
                  removeAddUser
                />
              ) : (
                '-'
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ASSIGNEES?.visible ? 'display-none' : '',
      },
      {
        title: 'Control Frequency',
        width: '100px',
        render: (text, record) => (
          <div className="">
            {record?.control_frequency}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.CONTROL_FREQUENCY?.visible ? 'display-none' : '',
      },
      {
        title: 'Products',
        width: '100px',
        render: (text, record) => (
          <div>
            {record?.products?.length}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PRODUCT_COUNT?.visible ? 'display-none' : '',
      },
      {
        title: '',
        key: 'action',
        className: 'list__actions-column',
        fixed: 'right',
        render: (record) => (
          <div className="list__actions">
            {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
              Helpers.permissionTypes.DELETE, user) && (
                <Popconfirm
                  placement="topRight"
                  title="Are you sure you want to delete this Quality Control Rule?"
                  onConfirm={() => {
                    const payload = {
                      group_id: record?.group_id,
                    };
                    deleteQCPointGroup(payload, () => {
                      setCall(!call);
                    });
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <div
                    className="list__actions-button-delete"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </div>
                </Popconfirm>
              )}
            {!isPortrait && Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES,
              Helpers.permissionTypes.UPDATE, user) && (
                <div
                  className="list__actions-button"
                  onClick={() => {
                    setShowUpdateQCPointModal(true);
                    setSelectedQCPoint(record);
                  }}
                >
                  <FontAwesomeIcon icon={faPen} />
                </div>
              )}
            {!isPortrait && (
              <div
                className="list__actions-button list__actions-button-dark"
                onClick={() => {
                  setShowUpdateProductGroupModal(true);
                  setSelectedQCPoint(record);
                }}
              >
                View
              </div>
            )}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
    ];
    return qcPointColumns.filter((item) => !item.hidden);
  };

  const pushParamsToUrl = (page, limit, word, defaultAssignee, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (defaultAssignee) url += `&defaultAssignee=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    // const restrictAccountManagerPermissionCheck = (window.location.href.includes('/estimate')) ? (user?.tenant_info?.sales_config?.sub_modules?.sales_estimate?.settings?.restrict_estimate_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_estimate)) : (user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.restrict_orders_of_other_acc_manager && !(user?.tenant_info?.permission?.allow_all_access_to_so));

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'defaultAssignee',
        filter_value: Helpers.getValueFromUrl('defaultAssignee') ? Helpers.getValueFromUrl('defaultAssignee')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim() || '',
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase() || '',
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    const restrictAccountManagerPermissionCheck = Helpers.getValueFromUrl('onlyApprover') === 'true' ? true : false;

    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'defaultAssignee',
        filter_value: restrictAccountManagerPermissionCheck ? [{
          userId: user?.user_id,
          title: `${user?.first_name} ${user?.last_name}`?.trim(),
          identity: user?.first_name?.substring(0, 2).toUpperCase(),
        }] : [],
        filter_type: filterTypeEnums.ARRAY,
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.QUALITY_RULES,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      setSelectedFilterView(systemDefaultUserView);
      getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
        // setSelectedAssignee(Helpers.getValueFromUrl('defaultAssignee') ? Helpers.getValueFromUrl('defaultAssignee')?.split(',')?.map((item) => ({
        //   userId: parseInt(item),
        //   title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
        //   identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        // })) : []);
      });
    }
  }, []);

  // useEffect(() => {
  //   if (user?.tenant_info?.org_id) {
  //     getOrgUsers(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.READ)?.join(','), (orgUsersData) => {
  //       setSelectedAssignee(Helpers.getValueFromUrl('defaultAssignee') ? Helpers.getValueFromUrl('defaultAssignee')?.split(',')?.map((item) => ({
  //         userId: parseInt(item),
  //         title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
  //         identity: parseInt(item) == 0 ? 'UA' : orgUsersData?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
  //       })) : []);
  //     });
  //     setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
  //     setLimit(Helpers.getValueFromUrl('limit') || limit);
  //     setSearchKeyword(Helpers.getValueFromUrl('keyword'));
  //     setKeyword(Helpers.getValueFromUrl('keyword'));
  //     setIsUserReady(true);
  //     setShowNewQCPointModal(Helpers.getValueFromUrl('toCreate') && Boolean(Helpers.getValueFromUrl('toCreate')));
  //     setSelectedEmails([user?.email]);
  //   }
  // }, []);
  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedAssignee(tempFilterValues.defaultAssignee);
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedAssignee, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getQCPoints(user?.tenant_info?.tenant_id, '', '', '', '', '', '', '', Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('defaultAssignee'));
    }
  }, [searchKeyword, currentPage, limit, isReady, call, selectedAssignee]);

  const downloadHandler = () => {
    getQCPointsReport(user?.tenant_info?.tenant_id, selectedEmails, user?.user_id, () => {
      setOpenPopover(false);
    });
  };

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for quality control rules..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                {Helpers.getPermission(Helpers.permissionEntities.QUALITY_RULES, Helpers.permissionTypes.CREATE, user) && (
                  <div className="doc-list__buttons-wrapper">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Quality Rule"
                      onClick={() => {
                        setShowNewQCPointModal(true);
                      }}
                      customClass="add-button hide__in-mobile"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedAssignee(tempFilterValues.defaultAssignee);
                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.QUALITY_RULES}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && searchKeyword?.length > 0 && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }}>
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
              </div>
            </div>

            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      {`${(qualityControlPoints && qualityControlPoints?.count) ? qualityControlPoints?.count : '0'} Total Quality Control Rules`}
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="select-user__filter-wrapper">
                          <SelectUser
                            selectedUsers={selectedAssignee}
                            onSelect={(userId) => {
                              setCurrentPage(1)
                              setSelectedAssignee([...selectedAssignee, {
                                userId,
                                title: userId === 0 ? 'Unassigned' : `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                                identity: userId === 0 ? 'UA' : orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                              }]);
                            }}
                            onRemove={(userId) => {
                              setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                            }}
                            disabled={!Helpers.getPermission(Helpers.permissionEntities.QUALITY_CHECKS, Helpers.permissionTypes.UPDATE, user)}
                          />
                        </div>
                        {qualityControlPoints?.count > 0 && (
                          <Popover
                            placement="bottom"
                            trigger="click"
                            title={<div style={{ width: '280px' }}>Please provide your email address</div>}
                            open={openPopover}
                            onOpenChange={() => setOpenPopover(!openPopover)}
                            content={(
                              <React.Fragment>
                                <div>
                                  <PRZSelect
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    mode="tags"
                                    filterOption={false}
                                    value={selectedEmails}
                                    onChange={(value) => setSelectedEmails(value)}
                                    disabled={getQCPointsReportLoading}
                                    maxTagCount="responsive"
                                    style={{
                                      width: '300px',
                                      height: 'auto !important',
                                    }}
                                  >

                                    {selectedEmails.length > 0 ? (
                                      selectedEmails.map((item) => (
                                        <Option key={item} value={item}>
                                          {item}
                                        </Option>
                                      ))
                                    ) : (
                                      <Option key={user?.email} value={user?.email}>
                                        {user?.email}
                                      </Option>
                                    )}
                                  </PRZSelect>
                                </div>
                                <div>
                                  <H3Button
                                    text="Send"
                                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                    onClick={() => { downloadHandler(); }}
                                    customClass="email-submit"
                                    isLoading={getQCPointsReportLoading}
                                    disabled={getQCPointsReportLoading}
                                  >
                                    Send

                                  </H3Button>
                                </div>

                              </React.Fragment>
                            )}
                          >
                            <div
                              className={`download-btn ${getQCPointsReportLoading ? 'download-btn__disabled' : ''} `}
                              onClick={() => {
                                setOpenPopover(true);
                              }}
                            >
                              <H3Text
                                text={(
                                  <FontAwesomeIcon icon={faDownload} />
                                )}
                                className="action-button"
                              />
                            </div>
                          </Popover>
                        )}
                      </div>
                      <Dropdown
                        overlay={(
                          <div className="custom-columns__content">
                            <div className="custom-columns__content-section">
                              <H3Text text="Visible Columns" className="custom-columns__content-title" />
                              {
                                Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                  <div key={key}>
                                    <Checkbox
                                      disabled={fixedColumns.includes(key)}
                                      checked={visibleColumns[key]?.visible}
                                      onChange={(value) => {
                                        const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                        visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                        localStorage.setItem('prcz-page-columns-qcr', JSON.stringify(visibleColumnsCopy));
                                        setVisibleColumns(visibleColumnsCopy);
                                      }}
                                    >
                                      {visibleColumns[key]?.label}
                                    </Checkbox>
                                  </div>
                                ))
                              }
                            </div>
                            {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                              <div className="custom-columns__content-section">
                                <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={(value) => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-qcr', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                            ) : ''}
                          </div>
                        )}
                        trigger={['click']}
                        placement="bottomRight"
                      >
                        <div className="custom-columns__wrapper">
                          Customize Columns
                          <ControlOutlined />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                )}
                loading={qualityControlPointsLoading || deleteQCPointGroupLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                columns={getQCPointColumns()}
                dataSource={qualityControlPoints && qualityControlPoints?.quality_control_rules ? qualityControlPoints?.quality_control_rules : []}
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: qualityControlPoints ? qualityControlPoints?.count : 0,
                    pageSize: limit,
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
                bordered
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        visible={showNewQCPointModal}
        onClose={() => setShowNewQCPointModal(false)}
        width="1020px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '980px' }}>
            <H3Text text="Create Quality Control Rule" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewQCPointModal(false)} />
          </div>
        </div>
        <QCPointForm
          callback={() => {
            getQCPoints(user?.tenant_info?.tenant_id, '', '', '', '', '', '', '', currentPage, 10, Helpers.getValueFromUrl('keyword'));
            setShowNewQCPointModal(false);
          }}
        />
      </Drawer>
      <Drawer
        visible={showUpdateQCPointModal}
        onClose={() => setShowUpdateQCPointModal(false)}
        width="1020px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '980px' }}>
            <H3Text text="Update Quality Control Point" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateQCPointModal(false)} />
          </div>
        </div>
        <QCPointForm
          selectedQCPoint={selectedQCPoint}
          callback={() => {
            getQCPoints(user?.tenant_info?.tenant_id, '', '', '', '', '', '', '', currentPage, 10, Helpers.getValueFromUrl('keyword'));
            setShowUpdateQCPointModal(false);
          }}
        />
      </Drawer>
      <Drawer
        visible={showUpdateProductGroupModal}
        onClose={() => setShowUpdateProductGroupModal(false)}
        width="400px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '355px' }}>
            <H3Text text="Update Product Group" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateProductGroupModal(false)} />
          </div>
        </div>
        <UpdateProductGroup
          productsGroup={selectedQCPoint?.products}
          selectedQCPoint={selectedQCPoint}
          onClose={() => {
            setShowUpdateProductGroupModal(false);
            getQCPoints(user?.tenant_info?.tenant_id, '', '', '', '', '', '', '', currentPage, 10, Helpers.getValueFromUrl('keyword'));
          }}
        />
      </Drawer>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`${selectedQCPointForMobile?.qcr_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          description={selectedQCPointForMobile?.description}
          customFields={selectedQCPointForMobile?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedQCPointForMobile })}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers, QCPointReducers, TenantReducers }) => ({
  user: UserReducers.user,
  qualityControlPointsLoading: QCPointReducers.qualityControlPointsLoading,
  deleteQCPointGroupLoading: QCPointReducers.deleteQCPointGroupLoading,
  qualityControlPoints: QCPointReducers.qualityControlPoints,
  getQCPointsReportLoading: QCPointReducers.getQCPointsReportLoading,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getQCPoints: (tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId) => dispatch(
    QCPointActions.getQCPoints(tenantId, groupId, operation, productSkuId, accessControl, departmentId, sellerId, category, page, limit, searchKeyword, defaultAssigneeId),
  ),
  deleteQCPointGroup: (payload, callback) => dispatch(QCPointActions.deleteQCPointGroup(payload, callback)),
  getQCPointsReport: (tenantId, selectedEmails, userId, callback) => dispatch(QCPointActions.getQCPointsReport(tenantId, selectedEmails, userId, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QCPointList));
